/** Zentrale Branding-Quelle für VeWorld / WalletConnect / DAppKit / PWA / OG. */

export const V3TAX_ICON_VERSION = "20260514-veworld-splash-v1";



export const V3TAX_ICON_16 = "/v3tax-veworld-icon-16-20260514.png";

export const V3TAX_ICON_32 = "/v3tax-veworld-icon-32-20260514.png";

export const V3TAX_ICON_180 = "/v3tax-veworld-icon-180-20260514.png";

export const V3TAX_ICON_192 = "/v3tax-veworld-icon-192-20260514.png";

export const V3TAX_ICON_512 = "/v3tax-veworld-icon-512-20260514.png";

export const V3TAX_MASKABLE_ICON_512 = "/v3tax-veworld-maskable-512-20260514.png";

export const V3TAX_FAVICON_ICO = "/v3tax-veworld-icon-20260514.ico";

export const V3TAX_MANIFEST_PATH = "/manifest.webmanifest";



/** Für VeWorld, WalletConnect und Mobile UI immer das große harte Icon verwenden. */

export const V3TAX_MOBILE_LOGO_PATH = V3TAX_ICON_512;

/** Logo für V3Tax-Kauf-Zeilen in Transfer-/Tax-Tabellen */
export const V3TAX_PURCHASE_LOGO_PATH = "/logo copy.png";



export const V3TAX_PRODUCTION_ORIGIN = "https://v3tax.app";
export const V3TAX_STAGING_ORIGIN = "https://staging.v3tax.app";

/** Erzwingt WalletConnect-localStorage-Clear, wenn sich Metadaten ändern. */

export const WC_METADATA_VERSION = `wc-metadata-${V3TAX_ICON_VERSION}`;

/**
 * Canonical public origin for the running environment.
 * Production → v3tax.app, staging → staging.v3tax.app, local → window origin.
 * Never hardcode a foreign environment mid-component.
 */
export function resolveV3TaxPublicOrigin({
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
  envAppUrl = typeof import.meta !== "undefined"
    ? import.meta.env?.VITE_APP_URL
    : "",
  isProd = typeof import.meta !== "undefined" ? import.meta.env?.PROD : false,
} = {}) {
  const host = String(hostname || "").toLowerCase();

  if (host === "localhost" || host === "127.0.0.1") {
    return `http://${host}${typeof window !== "undefined" && window.location.port ? `:${window.location.port}` : ""}`;
  }

  if (host === "staging.v3tax.app" || host.endsWith(".staging.v3tax.app")) {
    return V3TAX_STAGING_ORIGIN;
  }

  if (host === "v3tax.app" || host === "www.v3tax.app") {
    return V3TAX_PRODUCTION_ORIGIN;
  }

  const env = String(envAppUrl || "").replace(/\/$/, "");
  if (/staging\.v3tax\.app/i.test(env)) return V3TAX_STAGING_ORIGIN;
  if (/v3tax\.app/i.test(env) && !/staging/i.test(env)) {
    return V3TAX_PRODUCTION_ORIGIN;
  }

  if (isProd) return V3TAX_PRODUCTION_ORIGIN;
  return env || V3TAX_PRODUCTION_ORIGIN;
}

/**
 * Clean URL shown in browser print headers/footers.
 * Omits /analyze/:id query paths so customer PDFs do not leak dataset URLs.
 */
export function buildV3TaxReportPrintUrl(options = {}) {
  const origin = resolveV3TaxPublicOrigin(options).replace(/\/$/, "");
  return `${origin}/`;
}

export function assertProductionReportUrlSafe(url = "") {
  const s = String(url || "").toLowerCase();
  if (s.includes("staging.v3tax.app")) {
    throw new Error("Production report URL must not contain staging.v3tax.app");
  }
  if (s.includes("localhost") || s.includes("127.0.0.1")) {
    throw new Error("Production report URL must not contain localhost");
  }
  if (s.includes("/analyze/")) {
    throw new Error("Report print URL must not include /analyze/ dataset paths");
  }
  return true;
}

/** Production: feste HTTPS-Origin für WC/VeWorld-Metadaten (kein www-Mismatch). */

export function getV3TaxAppOrigin(origin) {

  if (typeof window !== "undefined") {

    const host = window.location.hostname;

    if (host === "localhost" || host === "127.0.0.1") {

      return window.location.origin.replace(/\/$/, "");

    }

  }



  const clean = String(origin || "").replace(/\/$/, "");

  if (/localhost|127\.0\.0\.1/.test(clean)) {

    return clean;

  }



  return V3TAX_PRODUCTION_ORIGIN;

}



export function getV3TaxAbsoluteIconUrl(origin) {

  return `${getV3TaxAppOrigin(origin)}${V3TAX_ICON_512}`;

}

